/**
 * chatUnread.ts — EINE Definition von „ungesehen" für Header-Badge und
 * Kommunikations-Übersicht.
 *
 * Die beiden Kanäle zählen bewusst unterschiedlich:
 *
 *  • Chat (Team/Kunden): ungelesene NACHRICHTEN aus `conv.unread` — der Wert
 *    kommt serverseitig aus den Read-Receipts (server_chat/lib/unread.js) und
 *    sinkt, sobald die Konversation gelesen wird.
 *
 *  • Anfragen (anonyme Website-Konversationen): OFFENE Anfragen, also alle, die
 *    nicht als erledigt markiert sind. Read-Receipts taugen hier nicht: eine
 *    Anfrage besteht meist aus einer einzigen Formular-Nachricht, die schon beim
 *    ersten Blick in die Liste als gelesen gilt — der Vorgang ist damit aber
 *    nicht abgearbeitet. „Erledigt" (options.status='done') ist der Zustand, den
 *    die Mitarbeiterin bewusst setzt, und den die Übersicht seit jeher zählt.
 *
 * Helpdesk-Konversationen (type='support') bleiben außen vor — dafür gibt es
 * einen eigenen Badge am Lebensretter-Icon im Header.
 */

export function isAnonConv (c: any): boolean {
  return c?.type === 'anonymous' || c?.type === 'anon'
}

/** Anfrage als erledigt markiert? (options ist mal String, mal Objekt) */
export function isRequestDone (c: any): boolean {
  try {
    const opts = typeof c?.options === 'string' ? JSON.parse(c.options) : (c?.options || {})
    return opts?.status === 'done'
  } catch { return false }
}

/** Offene (nicht erledigte) Website-Anfragen. */
export function openRequests (convs: any[]): any[] {
  return (convs || []).filter(c => isAnonConv(c) && !isRequestDone(c))
}

/** Konversationen des Chat-Kanals: weder Anfrage noch Helpdesk. */
export function chatConversations (convs: any[]): any[] {
  return (convs || []).filter(c => !isAnonConv(c) && c?.type !== 'support')
}

/** Ungelesene Chat-Nachrichten (Summe über alle Chat-Konversationen). */
export function countChatUnread (convs: any[]): number {
  return chatConversations(convs).reduce((sum, c) => sum + (Number(c?.unread) || 0), 0)
}
